import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-zonas',
  templateUrl: './zonas.component.html',
  styleUrls: ['./zonas.component.scss'],
  providers: [CommonService]
})
export class ZonasComponent implements OnInit {
  public ciudades:any[];
  public zonas:any[];
  public zona:any;

  constructor(private commonService:CommonService) { }

  ngOnInit() {
    this.zona = {
      ciudades_id: 0,
      nombre: ''
    };

    Promise.all([
      this.commonService.getCiudades(),
      this.commonService.getZonas()
    ]).then(result => { 
      this.ciudades = result[0];
      this.zonas = result[1];
    });
  }

  public getNombreCiudad(idCiudad):string {
    let result = '';

    this.ciudades.forEach(ciudad => {
      if (ciudad.id === idCiudad) {
        result = ciudad.nombre;
      }
    });

    return result;
  }

  public saveZona() {
    this.commonService
      .saveZona(this.zona)
      .then(() => {
        this.zona = {
          ciudades_id: 0,
          nombre: ''
        };
        this.commonService.getZonas()
          .then(result => this.zonas = result);
    });
  }

}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/carga/zonas/zonas.component.ts